import type { Node } from '@xyflow/react';
import { NodeEditModeEnum } from '../../workflow-sidebar/edit-node-form.types';

export enum NodeType {
  Enroll = 'enroll',
  Wait = 'wait',
  Action = 'action',
}

export enum StaticNodeType {
  Add = 'add',
  Start = 'start',
}

export type SidebarView =
  | { kind: NodeEditModeEnum.Library }
  | { kind: NodeEditModeEnum.EditExisting; node: Node }
  | { kind: NodeEditModeEnum.EditDraft; node: Node };
